
import Vue from 'vue';
import UpToTop20 from '@carbon/icons-vue/es/up-to-top/20';

export default Vue.extend({
  name: 'AiPreviewSlideMenu',

  components: {
    UpToTop20,
  },

  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    toggleMenu() {
      this.$emit('update:is-expanded', !this.isExpanded);
    },
    handleGenerateClick() {
      this.$emit('generate-image');
    },
  },
});
